import { render, staticRenderFns } from "./agent-sidebar.vue?vue&type=template&id=d46f98f0&scoped=true&"
import script from "./agent-sidebar.ts?vue&type=script&lang=ts&"
export * from "./agent-sidebar.ts?vue&type=script&lang=ts&"
import style0 from "./agent-sidebar.vue?vue&type=style&index=0&id=d46f98f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46f98f0",
  null
  
)

export default component.exports